import Vue from 'vue'
import Vuex from 'vuex'

import user from './user/user'
import settings from './settings/settings'

Vue.use(Vuex)
export default new Vuex.Store({
  modules: {
    user,
    settings
  },
  strict: false // process.env.NODE_ENV !== 'production'
})
